// extracted by mini-css-extract-plugin
module.exports = {"padded":"CourseManage_padded__2t0nW","renameContainer":"CourseManage_renameContainer__3VlHt"};